import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

const headerBgImage = 'https://storage.helloreaddy.io/project_files/fbab44cd-04c6-492b-a442-ed8f359ae362/aa133f5c-b70f-41c6-abe0-1cd52e276c5b_compressed_-2026-09-07-16.55.11.webp';

export default function AccessContent() {
  const { t } = useTranslation();

  return (
    <>
      {/* Section Header */}
      <section className="relative pt-16 md:pt-20 pb-12 md:pb-16 px-4 md:px-6 overflow-hidden">
        <img src={headerBgImage} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <p className="font-heading text-xs md:text-sm tracking-[0.3em] text-accent-300 mb-4">
            {t('access_label')}
          </p>
          <h2 className="font-heading text-2xl md:text-3xl tracking-wider text-white mb-4">
            {t('access_title')}
          </h2>
        </div>
      </section>

      {/* Map */}
      <ScrollReveal as="section" className="py-12 md:py-16 px-4 md:px-6 bg-transparent">
        <div className="max-w-5xl mx-auto">
          <div className="relative rounded-lg overflow-hidden border border-secondary-200/60">
            <iframe
              src="https://www.google.com/maps?q=ニッシングローリー池袋&output=embed"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={t('access_title')}
              className="w-full"
            />
            {/* Map marker overlay */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-full pointer-events-none">
              <div className="relative">
                <i className="ri-map-pin-fill text-4xl text-red-600 drop-shadow-lg" />
                <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-red-600 rounded-full opacity-40" />
              </div>
            </div>
          </div>
        </div>
      </ScrollReveal>

      {/* Store Info Grid */}
      <ScrollReveal as="section" className="py-16 md:py-20 px-4 md:px-6 bg-transparent">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-xl tracking-wider text-foreground-900 mb-2 text-center reveal-child">
            {t('info_title')}
          </h2>
          <p className="text-xs tracking-widest text-accent-600 text-center mb-10 font-label reveal-child reveal-delay-1">
            {t('info_subtitle')}
          </p>

          <div className="bg-background-50 rounded-lg border border-secondary-200/60 overflow-hidden">
            <div className="divide-y divide-secondary-200/40">
              <div className="flex flex-col sm:flex-row py-5 px-6">
                <span className="text-xs tracking-widest text-foreground-400 font-label w-full sm:w-32 flex-shrink-0 mb-1 sm:mb-0">
                  {t('info_name')}
                </span>
                <span className="text-sm text-foreground-800">{t('info_name_val')}</span>
              </div>
              <div className="flex flex-col sm:flex-row py-5 px-6">
                <span className="text-xs tracking-widest text-foreground-400 font-label w-full sm:w-32 flex-shrink-0 mb-1 sm:mb-0">
                  {t('info_address')}
                </span>
                <span className="text-sm text-foreground-800 whitespace-pre-line">
                  {t('info_address_val')}
                </span>
              </div>
              <div className="flex flex-col sm:flex-row py-5 px-6">
                <span className="text-xs tracking-widest text-foreground-400 font-label w-full sm:w-32 flex-shrink-0 mb-1 sm:mb-0">
                  {t('info_phone')}
                </span>
                <a href="tel:03-3980-5537" className="text-sm text-foreground-800 hover:text-accent-600 transition-colors">
                  {t('info_phone_val')}
                </a>
              </div>
              <div className="flex flex-col sm:flex-row py-5 px-6">
                <span className="text-xs tracking-widest text-foreground-400 font-label w-full sm:w-32 flex-shrink-0 mb-1 sm:mb-0">
                  {t('info_hours')}
                </span>
                <div className="text-sm text-foreground-800 space-y-1 whitespace-pre-line">
                  <p>{t('info_hours_val')}</p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row py-5 px-6">
                <span className="text-xs tracking-widest text-foreground-400 font-label w-full sm:w-32 flex-shrink-0 mb-1 sm:mb-0">
                  {t('info_closed')}
                </span>
                <span className="text-sm text-foreground-800">{t('info_closed_val')}</span>
              </div>
              <div className="flex flex-col sm:flex-row py-5 px-6">
                <span className="text-xs tracking-widest text-foreground-400 font-label w-full sm:w-32 flex-shrink-0 mb-1 sm:mb-0">
                  {t('info_seats')}
                </span>
                <span className="text-sm text-foreground-800">{t('info_seats_val')}</span>
              </div>
              <div className="flex flex-col sm:flex-row py-5 px-6">
                <span className="text-xs tracking-widest text-foreground-400 font-label w-full sm:w-32 flex-shrink-0 mb-1 sm:mb-0">
                  {t('info_payment')}
                </span>
                <span className="text-sm text-foreground-800">{t('info_payment_val')}</span>
              </div>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </>
  );
}